import { DomainMappingKind } from 'src/orchd-client';

export const isPrimaryDomain = (mappingKind?: DomainMappingKind) => mappingKind === DomainMappingKind.primary;
